import styled from 'styled-components';

export const Body = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;
	flex: 1;
`;
